<div class="row tax-planning-client template-strategy new-input-fields">
  <div class="medium-12 columns">
    <div class="row row-padding-reveal" [ngClass]="!selectedTemplate ? 'mb-5': ''">
      <div class="medium-2 columns">
        <div style="margin-top: 5px;">Templates</div>
      </div>
      <div class="medium-4 columns">
        <label>
          <app-tpiq-select-dropdown [setData]="templates" (onValueSelect)="setTemplate($event)"
                                 [setDefaultValue]="selectedTemplate" [setSearchKey]="'name'" [setPlaceHolder]="'Select Template'" [setValueKey]="'id'">
          </app-tpiq-select-dropdown>
        </label>
      </div>
    </div>
    <ng-template [ngIf]="selectedTemplate">
      <hr/>
      <div class="row row-padding-reveal">
        <div class="medium-8 columns" style="font-size: 17px; font-weight: 700;color: #16477a">
          <span style="font-family: Raleway-SemiBold;">{{selectedTemplateName || 'Template Info'}}</span>
        </div>
        <div class="medium-4 columns text-right">
          <button style="margin-bottom: 0;" class="button small" (click)="useTemplate()">Use Template</button>
        </div>
      </div>

      <div foundation class="row reports row-padding-reveal">
        <div class="medium-12 columns">
          <ul class="reports tabs" data-tabs id="report-tabs" style="padding: 0;">
            <li class="reports tabs-title" [ngClass]="{'is-active': currentView == 'strategies'}"><a id="a-strategies" (click)="switchPage('strategies')" aria-selected="true"><h6>Strategies</h6></a></li>
            <li class="reports tabs-title" [ngClass]="{'is-active': currentView == 'rates'}"><a id="a-rates"(click)="switchPage('rates')" aria-selected="false"><h6>Rates</h6></a></li>
            <li class="reports tabs-title" [ngClass]="{'is-active': currentView == 'fees'}"><a id="a-fees"(click)="switchPage('fees')" aria-selected="false"><h6>Fees</h6></a></li>
          </ul>
        </div>
        <div class="medium-12 columns">
          <div class="reports tabs-content" data-tabs-content="report-tabs" *ngIf="currentView == 'rates'">
            <ng-template [ngIf]="template.rates && template.rates.length == 0">
              <div class="body reveal-publish d-flex align-items-center justify-content-center" style="height: 10vh;">
                No rates added to this template.
              </div>
            </ng-template>
            <ng-template [ngIf]="template.rates && template.rates.length > 0">
              <div class="row mb-5">
                <div class="medium-2 column mt-3" *ngFor="let item of template.rates">
                  <div class="text-center">{{item.name}}</div>
                  <div class="text-center total-color pointer">
                    {{item.rate}}%
                  </div>
                </div>
              </div>
            </ng-template>
          </div>
          <div class="reports tabs-content" data-tabs-content="report-tabs" *ngIf="currentView == 'fees'">
            <div class="row no-hover client-todos tax-strategy client-plans mt-3" style="height: 45vh;overflow-y: auto;">
              <div class="medium-12 large-12 tpiq-paginated-table invoices scenarios">
                <table style="margin-top: 0 !important;">
                  <thead>
                  <tr>
                    <th *ngFor="let column of feesTableColumns">
                      <span>{{column.title}}</span>
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <ng-template [ngIf]="template.fees && template.fees.length == 0">
                    <tr class="text-center">
                      <td [attr.colspan]="feesTableColumns.length">
                        <div class="callout text-center">
                          <p>No fees added to this template.</p>
                        </div>
                      </td>
                    </tr>
                  </ng-template>
                  <ng-template [ngIf]="template.fees && template.fees.length > 0">
                    <tr *ngFor="let row of template.fees">
                      <td *ngFor="let col of feesTableColumns;let idx=index">
                        <div *ngIf="col.name == 'amount'">{{row[col.name]  | formatAmount:'$0,0'}}</div>
                        <div *ngIf="col.name != 'amount'">{{row[col.name]}}</div>
                      </td>
                    </tr>
                  </ng-template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="reports tabs-content" data-tabs-content="report-tabs" *ngIf="currentView == 'strategies'">
            <div class="row no-hover client-todos tax-strategy client-plans mt-3" style="height: 45vh;overflow-y: auto;">
              <div class="medium-12 large-12 tpiq-paginated-table invoices scenarios">
                <table style="margin-top: 0 !important;">
                  <thead>
                  <tr>
                    <th *ngFor="let column of strategiesTableColumns">
                      <span>{{column.title}}</span>
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <ng-template [ngIf]="template.strategies && template.strategies.length == 0">
                    <tr class="text-center">
                      <td [attr.colspan]="strategiesTableColumns.length">
                        <div class="callout text-center">
                          <p>No strategies added to this template.</p>
                        </div>
                      </td>
                    </tr>
                  </ng-template>
                  <ng-template [ngIf]="template.strategies && template.strategies.length > 0">
                    <tr *ngFor="let row of template.strategies">
                      <td *ngFor="let col of strategiesTableColumns;let idx=index">
                        <div *ngIf="col.name == 'amount'">{{row[col.name]  | formatAmount:'$0,0'}}</div>
                        <div *ngIf="col.name != 'amount'">{{row[col.name]}}</div>
                      </td>
                    </tr>
                  </ng-template>
                  </tbody>
                </table>
              </div>
            </div>

          </div>
        </div>
      </div>
    </ng-template>
  </div>
</div>


